import React, { useState, useEffect } from 'react';
import { changeUserPassword } from '../lib/api';
import { Dialog, DialogContent, DialogDescription, DialogFooter, DialogHeader, DialogTitle } from './ui/dialog';
import { Button } from './ui/button';
import { Input } from './ui/input';
import { Label } from './ui/label';
import { Eye, EyeOff, Loader2 } from 'lucide-react';
import { toast } from 'sonner';

export const ChangePasswordDialog = ({ open, onOpenChange, targetUser }) => {
  const [password, setPassword] = useState('');
  const [confirm, setConfirm] = useState('');
  const [show, setShow] = useState(false);
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    if (open) { setPassword(''); setConfirm(''); setShow(false); }
  }, [open]);

  const error = password && password.length < 6
    ? 'Mínimo 6 caracteres'
    : confirm && password !== confirm ? 'Las contraseñas no coinciden' : '';

  const submit = async (e) => {
    e.preventDefault();
    if (error || !password || !confirm) return;
    setSaving(true);
    try {
      await changeUserPassword(targetUser.id, password);
      toast.success(`Contraseña de ${targetUser.username} actualizada`);
      onOpenChange(false);
    } catch (err) {
      const d = err.response?.data?.detail;
      toast.error(typeof d === 'string' ? d : 'No se pudo cambiar la contraseña');
    } finally {
      setSaving(false);
    }
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="bg-card border-border" data-testid="change-password-dialog">
        <form onSubmit={submit}>
          <DialogHeader>
            <DialogTitle>Cambiar Contraseña</DialogTitle>
            <DialogDescription>Nueva contraseña para {targetUser?.username}</DialogDescription>
          </DialogHeader>
          <div className="space-y-4 py-4">
            <div className="space-y-2">
              <Label htmlFor="new-password">Nueva contraseña</Label>
              <div className="relative">
                <Input
                  id="new-password"
                  type={show ? 'text' : 'password'}
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  className="bg-secondary/50 pr-10"
                  autoComplete="new-password"
                  data-testid="new-password-input"
                />
                <button
                  type="button"
                  onClick={() => setShow(!show)}
                  className="absolute right-3 top-1/2 -translate-y-1/2 text-muted-foreground hover:text-foreground"
                  data-testid="toggle-password-visibility"
                >
                  {show ? <EyeOff className="w-4 h-4" /> : <Eye className="w-4 h-4" />}
                </button>
              </div>
            </div>
            <div className="space-y-2">
              <Label htmlFor="confirm-password">Confirmar contraseña</Label>
              <Input
                id="confirm-password"
                type={show ? 'text' : 'password'}
                value={confirm}
                onChange={(e) => setConfirm(e.target.value)}
                className="bg-secondary/50"
                autoComplete="new-password"
                data-testid="confirm-password-input"
              />
            </div>
            {error && <p className="text-sm text-destructive" data-testid="password-error">{error}</p>}
          </div>
          <DialogFooter>
            <Button type="button" variant="outline" onClick={() => onOpenChange(false)} data-testid="cancel-password-btn">
              Cancelar
            </Button>
            <Button type="submit" disabled={saving || !!error || !password || !confirm} data-testid="save-password-btn">
              {saving && <Loader2 className="w-4 h-4 mr-2 animate-spin" />}
              Guardar
            </Button>
          </DialogFooter>
        </form>
      </DialogContent>
    </Dialog>
  );
};
